import { useEffect } from 'react'

export const useComponentDidMount = (fn: () => void | Promise<void>) => {
  useEffect(() => {
    fn()
  }, [])
}
